module.exports = __webpack_public_path__ + "img/empty-bookings-icon.24546bbd.svg";